import { render, staticRenderFns } from "./DetailsButton.vue?vue&type=template&id=6875fb40&scoped=true&"
import script from "./DetailsButton.vue?vue&type=script&lang=js&"
export * from "./DetailsButton.vue?vue&type=script&lang=js&"
import style0 from "./DetailsButton.vue?vue&type=style&index=0&id=6875fb40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6875fb40",
  null
  
)

export default component.exports